(function () {
  'use strict';

  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments;
      clearTimeout(t);
      t = setTimeout(function () {
        fn.apply(null, args);
      }, wait);
    };
  }

  function safePlay(video) {
    if (!video) return;
    var p = video.play();
    if (p && typeof p.catch === 'function') {
      p.catch(function () {
        /* autoplay blocked; poster/first-frame remains visible */
      });
    }
  }

  function supportsSticky() {
    return !!(
      window.CSS &&
      CSS.supports &&
      (CSS.supports('position', 'sticky') || CSS.supports('position', '-webkit-sticky'))
    );
  }

  function initVideoSwap(root) {
    var desktopVideo = root.querySelector('[data-noc-video="desktop"]');
    var mobileVideo = root.querySelector('[data-noc-video="mobile"]');
    var mql = window.matchMedia('(max-width: 749px)');

    function apply() {
      var active = mql.matches ? mobileVideo || desktopVideo : desktopVideo || mobileVideo;
      var inactive = active === desktopVideo ? mobileVideo : desktopVideo;

      if (inactive && inactive !== active) inactive.pause();
      safePlay(active);
    }

    apply();

    if (mql.addEventListener) {
      mql.addEventListener('change', apply);
    } else if (mql.addListener) {
      mql.addListener(apply);
    }

    window.addEventListener('resize', debounce(apply, 200));
  }

  function initScrollLink(root) {
    var pin = root.querySelector('[data-noc-pin]');
    var copyA = root.querySelector('[data-noc-copy-a]');
    var lineEls = root.querySelectorAll('[data-noc-line]');

    if (!pin || !copyA || !lineEls.length) return;

    root.classList.add('nocturn-hero--enhanced');

    try {
      // Copy A's own exit range is read from its data attributes (falls back
      // to the original 0.00–0.20 if absent) so it stays in sync with however
      // the rest of the sequence is retimed.
      var copyAExitStart = parseFloat(copyA.getAttribute('data-exit-start'));
      var copyAExitEnd = parseFloat(copyA.getAttribute('data-exit-end'));
      if (isNaN(copyAExitStart)) copyAExitStart = 0;
      if (isNaN(copyAExitEnd)) copyAExitEnd = 0.2;

      // Each [data-noc-line] element gets an enter range and an optional exit
      // range. No exit attributes (e.g. the DEEP/GUARD panels) means it just
      // stays revealed once entered — the same "no exit" behavior the three
      // copy lines used to have before the fly-up stage was added.
      var lines = Array.prototype.map.call(lineEls, function (el) {
        var hasExit = el.hasAttribute('data-exit-start') && el.hasAttribute('data-exit-end');
        return {
          el: el,
          start: parseFloat(el.getAttribute('data-start')) || 0,
          end: parseFloat(el.getAttribute('data-end')) || 1,
          hasExit: hasExit,
          exitStart: hasExit ? parseFloat(el.getAttribute('data-exit-start')) : 0,
          exitEnd: hasExit ? parseFloat(el.getAttribute('data-exit-end')) : 0
        };
      });

      var ticking = false;

      // Fully reversible: opacity/transform are a pure function of the current
      // scroll progress, so scrolling up plays every stage backwards — panels
      // recede, the copy lines drop back down and reappear, Copy A returns.
      // Adjacent stages leave a dead zone between them so at any single
      // progress value only one stage is visible.
      var update = function () {
        ticking = false;

        var rect = root.getBoundingClientRect();
        var viewportHeight = window.innerHeight;
        var scrollable = rect.height - viewportHeight;
        var progress = scrollable > 0 ? -rect.top / scrollable : 0;
        progress = Math.max(0, Math.min(1, progress));

        var aSpan = copyAExitEnd - copyAExitStart;
        var tA;
        if (aSpan > 0) {
          tA = (progress - copyAExitStart) / aSpan;
        } else {
          tA = progress >= copyAExitStart ? 1 : 0;
        }
        tA = Math.max(0, Math.min(1, tA));
        copyA.style.opacity = String(1 - tA);
        copyA.style.transform = 'translateY(' + (-40 * tA) + 'px)';

        lines.forEach(function (line) {
          var enterSpan = line.end - line.start;
          var tEnter;
          if (enterSpan > 0) {
            tEnter = (progress - line.start) / enterSpan;
          } else {
            tEnter = progress >= line.start ? 1 : 0;
          }
          tEnter = Math.max(0, Math.min(1, tEnter));

          var tExit = 0;
          if (line.hasExit) {
            var exitSpan = line.exitEnd - line.exitStart;
            if (exitSpan > 0) {
              tExit = (progress - line.exitStart) / exitSpan;
            } else {
              tExit = progress >= line.exitStart ? 1 : 0;
            }
            tExit = Math.max(0, Math.min(1, tExit));
          }

          var opacity = tEnter * (1 - tExit);
          var y = 24 * (1 - tEnter) + -40 * tExit;

          line.el.style.opacity = String(opacity);
          line.el.style.transform = 'translateY(' + y + 'px)';
        });
      };

      var onScroll = function () {
        if (!ticking) {
          ticking = true;
          window.requestAnimationFrame(function () {
            try {
              update();
            } catch (e) {
              window.removeEventListener('scroll', onScroll);
              root.classList.remove('nocturn-hero--enhanced');
            }
          });
        }
      };

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', debounce(onScroll, 100));
      update();
    } catch (e) {
      // Anything going wrong while wiring up the scroll link (missing
      // attributes, layout API issues, etc.) must not leave the section
      // stuck with the enhanced 200vh min-height and no working pin —
      // drop back to the plain static layout instead.
      root.classList.remove('nocturn-hero--enhanced');
    }
  }

  function init() {
    var heroes = document.querySelectorAll('[data-noc-hero]');

    Array.prototype.forEach.call(heroes, function (root) {
      initVideoSwap(root);

      var reduceMotion =
        window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (reduceMotion || !('requestAnimationFrame' in window) || !supportsSticky()) {
        return;
      }

      initScrollLink(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
